<template>
	<div>
		<v-dialog
			v-model="show"
			width="600"
			content-class="confirm-action-modal overflow-x-hidden"
			@click:outside="closeModal"
		>
			<v-card class="confirm-action-modal__card">
				<div class="d-flex mb-4 align-center justify-center flex-wrap">
					<div class="confirm-action-modal__title text-center">
						{{ title }}
					</div>
				</div>
				<div class="button_group">
					<button
						style="border: 1.5px solid var(--accent-color)"
						type="button"
						class="confirm-action-modal__button action-cancel elevation-0"
						@click="closeModal"
					>
						Cancel
					</button>
					<button
						type="button"
						class="confirm-action-modal__button action-submit elevation-0"
						@click="confirmAction"
					>
						{{ actionName }}
					</button>
				</div>
				<button
					type="button"
					:disabled="isLoading"
					class="confirm-action-modal__button-close"
					style="background-color: #fff !important"
					@click="closeModal"
				>
					<v-icon color="#0055A3">mdi-close</v-icon>
				</button>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		actionName: {
			type: String,
			default: '',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		closeModal() {
			if (!this.isLoading) {
				this.$emit('closeModal')
			}
		},
		confirmAction() {
			if (!this.isLoading) {
				this.$emit('confirmAction')
			}
		},
	},
}
</script>

<style lang="scss">
.button_group {
	display: flex;
	justify-content: center;
	gap: 16px;
}
.confirm-action-modal {
	border-radius: 8px;

	&__card {
		padding: 24px;
	}
	&__title {
		color: var(--accent-color);
		font-size: 24px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		line-height: 100%;
		letter-spacing: 0;
	}
	&__button-close {
		position: absolute;
		top: 5px;
		right: 5px;
		width: 25px;
	}
	&__button {
		height: 46px;
		width: 146px;
		border-radius: 8px;
		font-family: 'Inter', sans-serif;
		font-size: 18px;
		font-weight: 700;
		text-transform: capitalize;

		&:disabled {
			border: none;
		}
	}
	.action {
		&-cancel {
			width: 146px !important;
			background: #fff !important;
			color: var(--accent-color) !important;
		}
		&-submit {
			width: 146px !important;
			background: var(--accent-color) !important;
			color: #fff !important;
		}
	}
}
</style>
